import * as S from './styles';

interface IPageTitleProps {
  title: string;
  subtitle?: string;
}

const PageTitle: React.FC<IPageTitleProps> = ({ title, subtitle }) => (
  <S.Container>
    <h1>{title}</h1>
    {!!subtitle && <h3>{subtitle}</h3>}
  </S.Container>
);

export default PageTitle;
